<template>
  <span>
    <svgicon
      v-if="status"
      name="ok"
      :width="size"
      :height="size"
      :color="passColor"
      :original="true">
    </svgicon>
    <svgicon
      v-else
      name="alert_circle"
      :width="size"
      :height="size"
      :color="failColor"
      :original="true">
    </svgicon>
  </span>
</template>

<script>
import insights from '@/mixins/insights';

export default {
  name: 'PassFailIcon',
  mixins: [insights],
  props: {
    status: {
      type: Boolean,
      required: true,
    },
    size: {
      type: String,
      required: true,
    },
  },
};
</script>
